import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#367C2B", // Green
    },
    secondary: { main: "#E4D00A" },
    text: {
      primary: "#000000", // Black
    },
    cancel: { main: "#ccc" },
  },
  typography: { useNextVariants: true },
});

export const internalQuoteDialogTheme = createTheme({
  palette: {
    primary: { main: "#fff494" },
    secondary: { main: "#367c2b" },
  },
  typography: { useNextVariants: true },
});

export const validationStatus = {
  TRUE: "true",
  FALSE: "false",
  ERROR: "error",
};

export const currencyPayload = { EUR: "€", GBP: "£" };
